import { useBackendApi } from "./backendApi";
import { SetupArea } from './setupAreas';


export function useSetupAreasService() {
  const backendApi = useBackendApi();

  const getAllSetupAreas = async () => {
    return await backendApi.get('/setupareas') as SetupArea[];
  }

  return {
    getAllSetupAreas,
  }
}
